import React, { useEffect, useState } from 'react';
import './css/CTABanner.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ctaBgImage from '../Assets/Image/CTA section.webp';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultCta = {
  heading: 'We Carry More Than Just Legal Expertise',
  subheading:
    'We provide uncompromising dedication and absolute loyalty to your business interests.',
  buttonText: 'GET IN TOUCH',
  backgroundImage: '',
};

const CTABanner = () => {
  const navigate = useNavigate();
  const [cta, setCta] = useState(defaultCta);

  useEffect(() => {
    const fetchCta = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/cta-banner`);
        if (res.data?.heading !== undefined) {
          setCta({
            ...defaultCta,
            ...res.data,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchCta();
  }, []);

  const handleGetInTouch = () => {
    navigate('/contact');
  };

  const bgImage =
    cta.backgroundImage && cta.backgroundImage.startsWith('http')
      ? cta.backgroundImage
      : cta.backgroundImage
        ? `${API_BASE_URL}${cta.backgroundImage}`
        : ctaBgImage;

  return (
    <section
      className="cta-wrapper"
      style={{ backgroundImage: `url("${bgImage}")` }}
    >
      <div className="container">
        <div className="cta-glass-pill">
          <div className="cta-content">
            <h2 className="cta-heading">{cta.heading}</h2>
            <p className="cta-subheading">{cta.subheading}</p>
            <button className="cta-button" onClick={handleGetInTouch}>
              {cta.buttonText}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
